import React, { useEffect, useState } from 'react'
import './ListItem.css'
import { Link } from 'react-router-dom'
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from '@material-ui/core'
import PickupIcon from '@material-ui/icons/Commute'
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import DashboardIcon from '@material-ui/icons/Dashboard'
import AssignmentIcon from '@material-ui/icons/Assignment'
import FlowIcon from '@material-ui/icons/Poll'
import ImportIcon from '@material-ui/icons/Event'
import ViewListRoundedIcon from '@material-ui/icons/ViewListRounded'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import PersonAddTwoToneIcon from '@material-ui/icons/AddAlert'
import InventoriesIcon from '@material-ui/icons/PermMediaTwoTone'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import HistoryIcon from '@material-ui/icons/History'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import MoneyIcon from '@material-ui/icons/Money'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import AcUnitIcon from '@material-ui/icons/AcUnit'
import EventIcon from '@material-ui/icons/Event'
import SportsIcon from '@material-ui/icons/Sports';
import StoreIcon from '@material-ui/icons/Store';

export const mainListItemsIfChemist = (
  <div className="sidebar">
    <Link to="/supply/dashboard" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </Link>
    <Link to="/supply/update-profile" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItem>
    </Link>
    <Link to="/chemist/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <ViewListRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Orders" />
      </ListItem>
    </Link>
    <Link to="/chemist/invoices" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="Invoices" />
      </ListItem>
    </Link>
    <Link to="/chemist/scheme-list" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Scheme" />
      </ListItem>
    </Link>
    <Link to="/chemist/goods-return" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AssignmentReturnIcon />
        </ListItemIcon>
        <ListItemText primary="Return/Bounce" />
      </ListItem>
    </Link>
  </div>
)

export const mainListItemsIfWholesaler = (
  <div className="sidebar">
    <Link to="/supply/dashboard" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </Link>
    <Link to="/supply/update-profile" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItem>
    </Link>
    <Link to="/wholesaller/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <ViewListRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Orders" />
      </ListItem>
    </Link>
    <Link to="/wholesaller/import" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <ImportIcon />
        </ListItemIcon>
        <ListItemText primary="Import Product" />
      </ListItem>
    </Link>
  </div>
)

export const mainListItems = (
  <div className="sidebar">
    <Link to="/activity/dashboard" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </Link>
    <Link to="/activity/profile" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItem>
    </Link>
    <Link to="/retailer/all-products" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <ViewListRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Products" />
      </ListItem>
    </Link>
    <h6 className="mt-3 mb-2 ml-2">Software</h6>
    <Link to="/retailer/parties" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PersonAddIcon />
        </ListItemIcon>
        <ListItemText primary="Parties" />
      </ListItem>
    </Link>
    <Link to="/retailer/all-product-and-sales" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Product And Sales" />
      </ListItem>
    </Link>
    <Link to="/retailer/all-product-and-purchase" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <InsertDriveFileIcon />
        </ListItemIcon>
        <ListItemText primary="Product And Purchase" />
      </ListItem>
    </Link>
    <Link to="/retailer/purchase-history" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="Purchase History" />
      </ListItem>
    </Link>
    <Link to="/retailer/sales-history" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="Sales History" />
      </ListItem>
    </Link>
    <Link to="/retailer/my-team" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PersonAddTwoToneIcon />
        </ListItemIcon>
        <ListItemText primary="My Team" />
      </ListItem>
    </Link>
    <Link to="/retailer/inventories" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <InventoriesIcon />
        </ListItemIcon>
        <ListItemText primary="Inventories" />
      </ListItem>
    </Link>
  </div>
)

export const mainListItemsIfPlanAdmin = (
  <div className="sidebar">
    <Link to="/activity/dashboard" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </Link>
    <Link to="/activity/profile" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItem>
    </Link>
    <h6 className="mt-3 mb-2 ml-2">Supply Order</h6>
    <Link to="/supply/medicine" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AcUnitIcon />
        </ListItemIcon>
        <ListItemText primary="Supply Medicine" />
      </ListItem>
    </Link>
    <Link to="/supply/create-order-generate-invoice" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="COGI Flow" />
      </ListItem>
    </Link>
    <Link to="/supply/invoice-history" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="Invoice History" />
      </ListItem>
    </Link>
    <Link to="/supply/users" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PersonAddIcon />
        </ListItemIcon>
        <ListItemText primary="Partners" />
      </ListItem>
    </Link>
    <Link to="/supply/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Orders" />
      </ListItem>
    </Link>
    <Link to="/supply/frequently/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <FlowIcon />
        </ListItemIcon>
        <ListItemText primary="Frequently Orders" />
      </ListItem>
    </Link>
    <Link to="/supply/scheme-list" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Scheme" />
      </ListItem>
    </Link>
    <Link to="/supply/distribution" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PickupIcon />
        </ListItemIcon>
        <ListItemText primary="Distribution" />
      </ListItem>
    </Link>
    <Link to="/supply/filter-medicine" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Filter Medicine" />
      </ListItem>
    </Link>
    <Link to="/supply/goods-return" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AssignmentReturnIcon />
        </ListItemIcon>
        <ListItemText primary="Return/Bounce" />
      </ListItem>
    </Link>
  </div>
)

export const mainListItemsIfPlanSubAdmin = (
  <div className="sidebar">
    <Link to="/activity/dashboard" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </Link>
    <Link to="/activity/profile" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItem>
    </Link>
    <h6 className="mt-3 mb-2 ml-2">Supply Order</h6>
    <Link to="/supply/medicine" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AcUnitIcon />
        </ListItemIcon>
        <ListItemText primary="Supply Medicine" />
      </ListItem>
    </Link>
    <Link to="/supply/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Orders" />
      </ListItem>
    </Link>
    <Link to="/supply/frequently/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <FlowIcon />
        </ListItemIcon>
        <ListItemText primary="Frequently Orders" />
      </ListItem>
    </Link>
    <Link to="/supply/distribution" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PickupIcon />
        </ListItemIcon>
        <ListItemText primary="Distribution" />
      </ListItem>
    </Link>
    <Link to="/supply/filter-medicine" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Filter Medicine" />
      </ListItem>
    </Link>
    <Link to="/supply/goods-return" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AssignmentReturnIcon />
        </ListItemIcon>
        <ListItemText primary="Return/Bounce" />
      </ListItem>
    </Link>
    <Link to="/supply/scheme-list" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Scheme" />
      </ListItem>
    </Link>
    <Link to="/supply/users" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PersonAddIcon />
        </ListItemIcon>
        <ListItemText primary="Partners" />
      </ListItem>
    </Link>
  </div>
)

export const mainListItemsIfPlanExpire = (
  <div className="sidebar">
    {/* <Link to="/retailer/ict-plan" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AcUnitIcon />
        </ListItemIcon>
        <ListItemText primary="Current Plan" />
      </ListItem>
    </Link> */}
  </div>
)

export const mainListItemsIfPlanAdminBackup = (
  <div className="sidebar">
    <Link to="/activity/dashboard" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>
    </Link>
    <Link to="/activity/profile" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AccountBoxIcon />
        </ListItemIcon>
        <ListItemText primary="Profile" />
      </ListItem>
    </Link>
    <Link to="/retailer/all-products" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <ViewListRoundedIcon />
        </ListItemIcon>
        <ListItemText primary="Products" />
      </ListItem>
    </Link>
    <Link to="/retailer/health-camps" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AcUnitIcon />
        </ListItemIcon>
        <ListItemText primary="Health Camps" />
      </ListItem>
    </Link>
    <Link to="/retailer/pharma-events" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <EventIcon />
        </ListItemIcon>
        <ListItemText primary="Pharma Events" />
      </ListItem>
    </Link>
    <Link to="/retailer/sport-events" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <SportsIcon />
        </ListItemIcon>
        <ListItemText primary="Sport Events" />
      </ListItem>
    </Link>
    <Link to="/retailer/franchise-events" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <StoreIcon />
        </ListItemIcon>
        <ListItemText primary="Franchise" />
      </ListItem>
    </Link>
    <h6 className="mt-3 mb-2 ml-2">Supply Order</h6>
    <Link to="/supply/medicine" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AcUnitIcon />
        </ListItemIcon>
        <ListItemText primary="Supply Medicine" />
      </ListItem>
    </Link>
    <Link to="/supply/create-order-generate-invoice" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="COGI Flow" />
      </ListItem>
    </Link>
    <Link to="/supply/invoice-history" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="Invoice History" />
      </ListItem>
    </Link>
    <Link to="/supply/users" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PersonAddIcon />
        </ListItemIcon>
        <ListItemText primary="Partners" />
      </ListItem>
    </Link>
    <Link to="/supply/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="Orders" />
      </ListItem>
    </Link>
    <Link to="/supply/frequently/order" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <FlowIcon />
        </ListItemIcon>
        <ListItemText primary="Frequently Orders" />
      </ListItem>
    </Link>
    <Link to="/supply/scheme-list" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Scheme" />
      </ListItem>
    </Link>
    <Link to="/supply/distribution" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PickupIcon />
        </ListItemIcon>
        <ListItemText primary="Distribution" />
      </ListItem>
    </Link>
    <Link to="/supply/filter-medicine" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Filter Medicine" />
      </ListItem>
    </Link>
    <Link to="/supply/goods-return" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <AssignmentReturnIcon />
        </ListItemIcon>
        <ListItemText primary="Return/Bounce" />
      </ListItem>
    </Link>
    <h6 className="mt-3 mb-2 ml-2">Software</h6>
    <Link to="/retailer/parties" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PersonAddIcon />
        </ListItemIcon>
        <ListItemText primary="Parties" />
      </ListItem>
    </Link>
    <Link to="/retailer/all-product-and-sales" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MoneyIcon />
        </ListItemIcon>
        <ListItemText primary="Product And Sales" />
      </ListItem>
    </Link>
    <Link to="/retailer/all-product-and-purchase" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <InsertDriveFileIcon />
        </ListItemIcon>
        <ListItemText primary="Product And Purchase" />
      </ListItem>
    </Link>
    <Link to="/retailer/purchase-history" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <HistoryIcon />
        </ListItemIcon>
        <ListItemText primary="Purchase History" />
      </ListItem>
    </Link>
    <Link to="/retailer/sales-history" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <MonetizationOnIcon />
        </ListItemIcon>
        <ListItemText primary="Sales History" />
      </ListItem>
    </Link>
    <Link to="/retailer/my-team" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <PersonAddTwoToneIcon />
        </ListItemIcon>
        <ListItemText primary="My Team" />
      </ListItem>
    </Link>
    <Link to="/retailer/inventories" className="sidebar__text">
      <ListItem button>
        <ListItemIcon>
          <InventoriesIcon />
        </ListItemIcon>
        <ListItemText primary="Inventories" />
      </ListItem>
    </Link>
  </div>
)